
import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const TooltipArrowIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        {...props}
        ref={ref}
        fill='none'
    >
        <path fill='currentColor' d='M2.581 2.06 1.533 3.327A1.86 1.86 0 0 1 .1 4v1h10.8V4a1.86 1.86 0 0 1-1.434-.672L8.385 2.02c-.398-.481-.747-.904-1.067-1.215-.34-.33-.745-.634-1.28-.748a2.59 2.59 0 0 0-1.076 0c-.536.114-.94.418-1.28.748-.32.311-.67.734-1.067 1.215l-.034.04Z'/>
        <path fill='rgb(var(--time-webkit-color-secondary-rgb, 0 0 0), 0.12)' d='M1.534 3.328 2.615 2.02c.398-.481.747-.904 1.067-1.215.34-.33.745-.634 1.28-.748a2.59 2.59 0 0 1 1.076 0c.536.114.94.418 1.28.748.32.311.67.734 1.067 1.215l.034.04 1.048 1.27c.35.423.875.671 1.433.671v1a2.86 2.86 0 0 1-2.204-1.035L7.648 2.696C6.796 1.665 6.37 1.15 5.83 1.035a1.59 1.59 0 0 0-.66 0c-.54.114-.965.63-1.817 1.661L2.305 3.965 2.275 4A2.86 2.86 0 0 1 .1 5V4a1.86 1.86 0 0 0 1.434-.672Z'/>
    </svg>
));
